import { useCallback } from "react";

import type { ReservationDetailUpdateHostMemoInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "../../repository/mutation";

export const useUpdateReservationDetailUpdateHostMemo = (hotelID: string, reservationID: string) => {
	const { onUpdateReservationDetailUpdateHostMemo: _onUpdateReservationDetailUpdateHostMemo } =
		MutationRepository.useReservationDetailUpdateHostMemoUpdateMutation();

	/**
	 * 予約のメモの更新を実行
	 */
	const onUpdateReservationDetailUpdateHostMemo = useCallback(
		(hostMemo: ReservationDetailUpdateHostMemoInput["hostMemo"]) => {
			const input: ReservationDetailUpdateHostMemoInput = {
				hostMemo,
				hotelID,
				reservationID,
			} satisfies ReservationDetailUpdateHostMemoInput;
			_onUpdateReservationDetailUpdateHostMemo(input);
		},
		[_onUpdateReservationDetailUpdateHostMemo, hotelID, reservationID],
	);

	return {
		onUpdateReservationDetailUpdateHostMemo,
	};
};
